module.exports = __webpack_public_path__ + "static/media/search.7acf84ee.svg";